import { render, staticRenderFns } from "./MedicalScoreboard.vue?vue&type=template&id=48a9a9cc&scoped=true&"
import script from "./MedicalScoreboard.vue?vue&type=script&lang=js&"
export * from "./MedicalScoreboard.vue?vue&type=script&lang=js&"
import style0 from "./MedicalScoreboard.vue?vue&type=style&index=0&id=48a9a9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9a9cc",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QResponsive,QTable,QItemSection,QBtn,QImg,QCardActions} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QResponsive,QTable,QItemSection,QBtn,QImg,QCardActions}, component.options.components || {})
